import rehabApi from '@Apis/rehab.api';
import { ResolvedResponse } from '@innovyze/lib-am-common';
import { GetGroupSetResponse } from '@Types';

export const getGroupSets = () => {
	return rehabApi.get<ResolvedResponse>('/rehabTrees?listAllAndTrees=true&treeType=AGSet');
};

export const getGroupSet = (groupSetId: string) => {
	return rehabApi.get<GetGroupSetResponse>(`/rehabTree/${groupSetId}`);
};
